import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import OpusShareModalComponent from '../components/ymx-opus-share/ymx-opus-share-modal.jsx';
import { closeOpusShareModal } from '../reducers/modals.js';
import {showStandardAlert} from '../reducers/alerts';

const tags = [
    { tag: '300354336377016320', intlLabel: "游戏" },
    { tag: '300354576077295616', intlLabel: "科技" },
    { tag: '300354640300478464', intlLabel: "艺术" },
    { tag: '300355313406578688', intlLabel: "动画" },
    { tag: '300355394604109824', intlLabel: "音乐" },
    { tag: '300355466439954432', intlLabel: "故事" },
    { tag: '300355536786821120', intlLabel: "其他" },
];

class OpusShareModal extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleKeyPress',
            'handleFocus',
            'handleOk',
            'handleChange',
            'handleTagClick',
            'handleChangeIntroText',
            'handleChangeOperationText',
            'handleCancel',
            'handleChangeKeyboardType'
        ]);
        this.state = {
            opusNameValue : window.scratchConfig.getProjectName(),
            selectedTags: [],
            introText: '',
            operationText: '',
            keyBoradType:"5"
        };
    }

    handleKeyPress(event) {
        if (event.key === 'Enter' && this.state.valueValid) {
            this.handleOk();
        }
    }

    handleFocus(event) {
        event.target.select();
    }

    async handleOk() {
        console.log(this.state.opusNameValue)
        console.log(this.state.selectedTags)
        console.log(this.state.introText)
        console.log(this.state.operationText)
        console.log(this.state.keyBoradType)
        
        let data = {
            opusNameValue:this.state.opusNameValue,
            selectedTags:this.state.selectedTags,
            introText:this.state.introText,
            operationText:this.state.operationText,
            keyBoradType:this.state.keyBoradType,
        }
        let result  = await window.scratchConfig.menuBar.pushOpusButton.handleClickPushOpusButton(data)
        console.log(result)
        if(result.code == 1){
            
            //请先保存后在发布
            this.props.onShowSaveFirstSaveErrorAlert();
            
        }else if(result.code == 0){
            this.props.onShowSavePushSuccessAlert();
            this.props.onCloseOpusShareModal();
            
        }else{
            if(result.data){
                this.props.onCloseOpusShareModal();
            }else{
                //发布失败
                this.props.onShowSavePushErrorAlert();
            }
        }
        
    }
    handleCancel(){
        this.props.onCloseOpusShareModal();
    }

    handleChange(e) {
        this.setState({
            opusNameValue: e.target.value,
        });
        window.scratchConfig.setProjectName(e.target.value)
    }

    handleTagClick(tag) {
        
        const { selectedTags } = this.state;
        if (selectedTags.includes(tag)) {
            this.setState({
                selectedTags: selectedTags.filter(t => t !== tag),
            });
        } else {
            this.setState({
                selectedTags: [...selectedTags, tag],
            });
        }
        
    }

    // 添加处理作品介绍和操作说明的函数
    handleChangeIntroText(e) {
        this.setState({ introText: e.target.value });
    }

    handleChangeOperationText(e) {
        this.setState({ operationText: e.target.value });
        
    }
    handleChangeKeyboardType(e){
        this.setState({ keyBoradType: e });
    }

    render() {
        return (
            <OpusShareModalComponent
                selectedTags={this.state.selectedTags} 
                opusNameValue={this.state.opusNameValue}
                onOpusNameChange={this.handleChange}
                introText={this.state.introText} 
                operationText={this.state.operationText} 
                onKeyPress={this.handleKeyPress}
                onFocus={this.handleFocus}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                tags={tags} 
                keyBoradType={this.state.keyBoradType}
                onChangekeyboardType={this.handleChangeKeyboardType}
                onTagClick={this.handleTagClick}
                onChangeIntroText={this.handleChangeIntroText} 
                onChangeOperationText={this.handleChangeOperationText} 
            />
        );
    }
}

OpusShareModal.propTypes = {
    onCloseOpusShareModal: PropTypes.func,
    onShowSaveFirstSaveErrorAlert: PropTypes.func,
    onShowSavePushErrorAlert: PropTypes.func,
    onShowSavePushSuccessAlert: PropTypes.func,
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
    onCloseOpusShareModal: () => dispatch(closeOpusShareModal()),
    onShowSaveFirstSaveErrorAlert:() => dispatch(showStandardAlert('firstSave')),
    onShowSavePushErrorAlert:()=> dispatch(showStandardAlert('pushError')),
    onShowSavePushSuccessAlert:()=> dispatch(showStandardAlert('pushSuccess')),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpusShareModal);